import React from "react"
import { Container } from "../containers/Container"
import { Main } from "./Main"
import { state } from "../containers/state"
import { ENV } from "../ENV"
import { FullPageLoading } from "./FullPageLoading"

type Props = {
  orgId: string
  authToken?: string
  graphqlUrl?: string
}

export function ComoReceber({
  orgId,
  authToken = ENV.AUTH_TOKEN,
  graphqlUrl = ENV.GQL_ENDPOINT,
}: Props) {
  ENV.AUTH_TOKEN = authToken
  ENV.GQL_ENDPOINT = graphqlUrl
  ENV.ORGANIZATION_ID = orgId

  return (
    <Container.Provider initialState={{ ...state, id: orgId }}>
      <FullPageLoading />
      <Main />
    </Container.Provider>
  )
}
